<template>
<div class="open-new-app">
  <el-breadcrumb class="breadcrumb" separator-class="el-icon-arrow-right">
    <el-breadcrumb-item :to="{ path: $const.route.OPEN_APP_DISPLAY }">业务申请</el-breadcrumb-item>
    <el-breadcrumb-item>申请公有云服务</el-breadcrumb-item>
  </el-breadcrumb>
  <div class="appform">
    <div class="appform__header">
      <div class="title-cont">申请公有云服务</div>
    </div>
    <el-form :model="newAppData" :rules="rules" ref="newAppData" @submit.native.prevent>
      <el-form-item label="应用名称:" prop="name">
        <el-input v-model="newAppData.name" placeholder="最多20个字符" :maxlength="20"></el-input>
      </el-form-item>
      <el-form-item label="应用简介:" class="intro-app" prop="description">
        <el-input
          type="textarea"
          v-model="newAppData.description"
          placeholder="需要说明在产品中使用腾讯优图的何种技术，以及具体的应用场景是什么(600字以内)"
          :maxlength="600">
        </el-input>
      </el-form-item>
      <el-form-item label="应用平台:" prop="platform">
        <el-checkbox-group v-model="newAppData.platform">
          <el-checkbox v-for="platform in OptionMapper.APPLY_PLATFORM" :label="platform.value" :key="platform.value">{{platform.label}}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="应用类型:" prop="softtype">
        <el-radio-group v-model="newAppData.softtype">
          <el-radio v-for="usage in OptionMapper.USAGE_TYPE" :label="usage.value" :key="usage.value">{{usage.label}}</el-radio>
        </el-radio-group>
      </el-form-item>
      <!-- <el-form-item label="接入产品类型:" prop="jointype">
        <el-checkbox-group v-model="newAppData.jointype">
          <el-checkbox v-for="joinType in OptionMapper.JOIN_TYPE" :label="joinType.value" :key="joinType.value">{{joinType.label}}</el-checkbox>
        </el-checkbox-group>
      </el-form-item> -->
      <el-form-item prop="joinway" class="form-item-left">
        <bubble
          slot="label"
          class="form-bubble"
          :bubbleInfo="tipConstant.scope">
        </bubble>
        <el-radio-group v-model="newAppData.joinway">
          <el-radio v-for="joinWay in OptionMapper.MAINSTAY_TYPE" :label="joinWay.value" :key="joinWay.value">{{joinWay.label}}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="应用地址:" prop="address">
        <el-input v-model="newAppData.address" placeholder="请填写网站地址或者真实的APP链接" :maxlength="300"></el-input>
      </el-form-item>
      <el-form-item label="说明:" class="explain-info">
        <div>请务必填写真实的应用信息，应用经过审核后方可使用，两个工作日内完成审核，请至业务申请页面查看审核结果。</div>
      </el-form-item>
    </el-form>
    <div class="c-btn-add" @click="handleSubmitApp">
      <span class="icon-plus"></span>
      <span class="text">提交申请</span>
    </div>
  </div>
</div>
</template>
<script>
import AppCreator from './js/AppCreator';
export default AppCreator;
</script>
<style lang="less">
@import "./css/app-creator.less";
</style>


// WEBPACK FOOTER //
// src/components/open/panels/application/panels/PublicCloudCreator.vue